const iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

export function isEnvironmentIOS() {
  if (navigator.platform) {
    for (let i = 0; i < iDevices.length; ++i) {
      if (navigator.platform === iDevices[i]) return true;
    }
  }
  return false;
}
